import { Injectable }     from '@angular/core';
import { CanActivate, Router }    from '@angular/router';

@Injectable()
export class OtherPathGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate() {

        if (localStorage.getItem("subdomain") === null) {
           localStorage.setItem("configured", 'false');
           localStorage.setItem("subdomain", window.location.host.split('.')[0]);
           this.router.navigate(['/ticket-search']);
           return false;
        }

        if (localStorage.getItem("configured") !== 'false') {
           this.router.navigate(['/ticket-search']);
           return false;
        }

        return true;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/other-path-guard.service.ts